import Vue from 'vue';
import _ from 'lodash';


const success = (context, index) => {
  const promoList = _.cloneDeep(context.promoList);
  promoList[index].is_editing = false;
  context.promoList = promoList;
  toastr.success(context.$t('booking.promo.edited'));
};

const failed = (error, context) => {
  context.showToasterError(error);
};

export default (context, data, index) => {
  return Vue.$http.put(`/promo-code/${data.id}`, data).then((response) => {
    if (response && response.status === 200) {
      success(context, index);
    }
  })
  .catch((error) => {
    failed(error, context);
  });
};



// WEBPACK FOOTER //
// ./src/app/services/account/updatePromoCode.js